export default {
  createProfile: 'ایجاد نمایه',
  editProfile: 'ویرایش نمایه',
  save: 'ذخیره',

  createAnalyseTemplate: 'ایجاد قالب تحلیل',
  editAnalyseTemplate: 'ویرایش قالب تحلیل',
  exit: 'خروج',
  successfullySaved: 'با موفقیت ذخیره شد.',
  profilePictureSuccessfullySaved:
    'لوگوی شرکت / عکس پروفایل با موفقیت ذخیره شد.',
  bannerSuccessfullySaved: ' عکس پس زمینه‌ی پروفایل با موفقیت ذخیره شد.',
  verticalBackgroundSuccessfullySaved:
    'عکس پس زمینه‌ی (در حالت عمودی) پروفایل با موفقیت ذخیره شد.',
  horizontalBackgroundSuccessfullySaved:
    'عکس پس زمینه‌ی (در حالت افقی) پروفایل با موفقیت ذخیره شد.',
  close: 'بستن',
  confirm: 'تایید',
  username: 'شناسه یکتا',
  useVirtualSpaces: 'نمایش پوشه به عنوان فضای مجازی',
  allowSeeThroughItems: 'مشاهده مسیر دسترسی به اسناد در دسترس',
  limitedAccount:
    'با توجه به عدم تسویه بدهی، دسترسی شما محدود به نسخه رایگان سامانه است',
  categories: 'دسته ها',
  tags: 'برچسب‌های اعمال شده به همه پاسخ‌ها',
  addCategory: 'افزودن دسته جدید',
  to: 'تا',

  addThisItemToAppMenu(name: string) {
    return 'افزودن «' + name + '» به منوی اپلیکیشن';
  },
  website: 'وب‌سایت',
  email: 'ایمیل',
  telegram_user: 'شناسه‌ی تلگرام',
  telegram_chanel: 'کانال تلگرام',
  instagram: 'شناسه‌ی اینستاگرام',
  aparat: 'آپارات',
  facebook: 'فیسبوک',
  linkedIn: 'لینکد‌این',
  userPhoneNumber: 'شماره‌ی تلفن جهت تماس کاربران',
  enterLinkedInUrl:
    'لطفا ادرس حساب لینکد‌این خود را به درستی وارد کنید.(https://linkdin.com/company/myCompany)',
  enterFacebookUrl:
    'لطفا ادرس حساب فیسبوک خود را به درستی وارد کنید.(https://facebook.com/myCompany)',
  enterAparatUrl:
    'لطفا ادرس حساب آپارات خود را به درستی وارد کنید.(https://www.aparat.com/myCompany)',
  enterSiteUrl:
    'لطفا ادرس وب‌سایت خود را به درستی وارد کنید.(http://mycompany.com)',
  enterTelegramId: 'لطفا شناسه‌ی تلگرام را به درستی وارد کنید.(@myComapanyId)',
  enterEmailUrl: 'لطفا ایمیل خود را به درستی وارد کنید.(contact@mycompany.com)',
  enterInstagramUrl:
    'لطفا آدرس تلگرام خود را را به درستی وارد کنید.(@myCompany)',
  name: 'نام شرکت/ شخص',
  address: 'آدرس',
  workingHours: 'ساعات کاری',
  postalCode: 'کد پستی',
  description: 'توضیحات',
  subject: 'زمینه‌ی فعالیت',
  phoneNumber: 'تلفن',
  selectTheLocationOnTheMap:
    'لطفاً مکان مورد نظر خود را در نقشه با دقت انتخاب کنید.',
  removeLocation: 'حذف موقعیت مکانی فعلی',
  socialNetworks: 'شبکه‌های اجتماعی و ارتباطات',
  profilePictures: 'تصاویر نمایه',
  generalInformation: 'اطلاعات کلی',
  contentManagement: 'مدیریت محتوا',
  relatedCompany: 'شرکت مرتبط',
  selectACompany: 'شرکتی انتخاب کنید',
  limitAccessToCompanyMembers(companyName: string) {
    return `دسترسی اسناد «${companyName}» فقط برای اعضای شرکت`;
  },
};
